module.exports = __webpack_public_path__ + "static/media/desktop-hero.03550a31.jpg";